module.exports = __webpack_public_path__ + "img/260_500.7534edc0.png";